import BaseClient from './BaseClient';
import type { AxiosPromise } from 'axios';

export interface IntegrationLogListItem {
    timestamp: string;
    vendor: string;
    has_errors: boolean;
    ptr: string | null;
}

export interface IntegrationLogEntry {
    team_id: number;
    vendor: string;
    timestamp: string;
    raw_payload: unknown;
    extracted_data: unknown[];
    events: unknown[];
    errors: unknown[];
    [key: string]: unknown;
}

export interface ListLogsParams {
    vendor?: string | null;
    status?: string | null;
    date_range?: string | null;
    cursor?: string | null;
}

export interface ListLogsResponse {
    data: IntegrationLogListItem[];
    next_cursor?: string;
    timed_out?: boolean;
}

export interface GetEntryResponse {
    data: IntegrationLogEntry | null;
}

class IntegrationLogsClient extends BaseClient {
    getLogs(teamId: number, params: ListLogsParams): AxiosPromise<ListLogsResponse> {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/integration-logs/list`, 'post', params);
    }

    getEntry(teamId: number, ptr: string): AxiosPromise<GetEntryResponse> {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/integration-logs/entry`, 'post', { ptr });
    }
}

export const integrationLogsClient = new IntegrationLogsClient();
